import { useState } from "react";
import { ReactComponent as PlusIcon } from "icons/plus.svg";
import AddKeywordModal from "./components/AddKeywordModal";
import KeywordPreviewModal from "./components/KeywordPreviewModal";
import Item from "./components/Item";
import { Dashboard } from "components";

const countries = ["PL", "UK", "DE", "ES", "FR", "IT", "SE", "NL"];

const CountryKeywords = ({ product_group_id, refetch, data = [] }) => {
  const [type, setType] = useState("PL");
  const [is_open_keyword_modal, handleOpenKeywordModal] = useState(false);
  const [is_open_keywords_preview, setOpenKeywordsPreview] = useState(false);

  const product_group_country_keywords_per_country_code = data.filter(
    ({ country_code }) => country_code === type
  );

  return (
    <Dashboard header={{ title: "Słowa kluczowe" }}>
      <div className="create-table" style={{ minHeight: 0, paddingBottom: 20 }}>
        {is_open_keyword_modal && (
          <AddKeywordModal
            product_group_id={product_group_id}
            refetch={refetch}
            country_code={type}
            handleClose={() => handleOpenKeywordModal(false)}
          />
        )}
        {is_open_keywords_preview && (
          <KeywordPreviewModal
            data={product_group_country_keywords_per_country_code}
            handleClose={() => setOpenKeywordsPreview(false)}
          />
        )}
        <ul className="panel-tabs">
          {countries.map((name) => (
            <li
              key={name}
              className={`tab dashboard-tab-text ${
                name === type ? "active" : ""
              }`}
              onClick={() => setType(name)}
            >
              {name}
            </li>
          ))}
        </ul>
        <table>
          <thead>
            <tr>
              <th>Nazwa</th>
              <th>Wolumen</th>
              <th>
                <button
                  disabled={
                    product_group_country_keywords_per_country_code.length === 0
                  }
                  className="btn btn-sm btn-blue"
                  onClick={() => setOpenKeywordsPreview(true)}
                >
                  <span>Kopiuj</span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            {product_group_country_keywords_per_country_code.length > 0 &&
              product_group_country_keywords_per_country_code.map((data) => (
                <Item key={data.id} {...data} refetch={refetch} />
              ))}
            <tr>
              <td>
                <button
                  className="create-table-btn"
                  type="button"
                  onClick={() => handleOpenKeywordModal(true)}
                >
                  <PlusIcon />
                  <span>Dodaj słowo kluczowe</span>
                </button>
              </td>
              <td />
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    </Dashboard>
  );
};

export default CountryKeywords;
